import { BeforeAfterType } from "src/api/types";
import nancy from "src/assets/before-and-afters/nancy.png";
import jen from "src/assets/before-and-afters/jen.png";
import beforeAfterNancy from "src/assets/before-and-afters/FHL1.png";
import beforeAfterJen from "src/assets/before-and-afters/FHL2.png";

export const berforeAfters: BeforeAfterType[] = [
  {
    id: 1,
    image: beforeAfterNancy,
    avatar: nancy,
    name: "Nancy E.",
  },
  {
    id: 2,
    image: beforeAfterJen,
    avatar: jen,
    name: "Jen F.",
  },
];
